import React, { useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import IconChevronDown from "assets/icon/IconChevronDown";
import IconX from "assets/icon/IconX";
import './select.scss';
function Select(props) {
    var _a, _b, _c;
    var data = props.data, label = props.label, value = props.value, onClick = props.onClick, onCancel = props.onCancel, _d = props.className, className = _d === void 0 ? '' : _d, _e = props.classNameLabel, classNameLabel = _e === void 0 ? '' : _e, _f = props.classNameIcon, classNameIcon = _f === void 0 ? '' : _f, labelIcon = props.labelIcon;
    var ulRef = useRef(null);
    var _g = useState(false), show = _g[0], setShow = _g[1];
    var _h = useState(0), height = _h[0], setHeight = _h[1];
    useEffect(function () {
        if (ulRef.current) {
            if (show) {
                setHeight(ulRef.current.scrollHeight);
            }
            else {
                setHeight(0);
            }
        }
    }, [show]);
    var main = classNames((_a = {
            'relative border border-black border-opacity-25 rounded-md hover:border-opacity-100': true,
            'border-primary border-opacity-100': value.id
        },
        _a[className] = className,
        _a));
    var divSelect = classNames({
        'flex items-center justify-between w-full pl-2 py-2 cursor-pointer': true,
        'pr-2': !value.id || !Boolean(onCancel)
    });
    var labelClassName = classNames((_b = {
            'text-14 text-black': true,
            'text-opacity-40': !value.title,
            'text-opacity-100': value.title
        },
        _b[classNameLabel] = classNameLabel,
        _b));
    var iconClassName = classNames((_c = {
            'absolute w-5 h-auto': true,
            'rtl:left-3 ltr:right-3 text-black': !Boolean(classNameIcon)
        },
        _c[classNameIcon] = classNameIcon,
        _c));
    return (React.createElement("div", { className: main },
        show ?
            React.createElement("div", { className: 'fixed z-10 top-0 right-0 w-full h-full', onClick: function () { return setShow(false); } })
            : null,
        React.createElement("div", { className: divSelect, onClick: function () { return setShow(true); } },
            React.createElement("div", { className: 'flex' },
                value.id && onCancel ?
                    React.createElement("div", { className: 'flex items-center rtl:ml-1 rtl:pr-2 ltr:mr-1 ltr:pl-2', onClick: function (e) {
                            e.stopPropagation();
                            onCancel();
                        } },
                        React.createElement(IconX, { className: 'w-4 h-auto text-black' }))
                    : null,
                labelIcon ? labelIcon : null,
                React.createElement("p", { className: labelClassName }, value.title || label)),
            React.createElement(IconChevronDown, { className: iconClassName })),
        React.createElement("ul", { ref: ulRef, className: 'absolute z-20 showItems bg-white rounded ltr:-right-1 rtl:-right-1 -top-1 shadow-md px-1 cursor-pointer overflow-hidden transition-height duration-200 ease-linear', style: { height: height } }, React.Children.toArray(data.map(function (item) {
            var listItem = classNames({
                'text-14 my-1 hover:bg-gray-200 hover:text-black text-black py-2 px-2 rounded': true,
                'bg-primary text-white shadow': value.id === item.id,
            });
            return (React.createElement("li", { className: listItem, onClick: function () {
                    if (onClick) {
                        setShow(false);
                        onClick(item);
                    }
                } }, item.title));
        })))));
}
export default Select;
